import { put, PutEffect } from "redux-saga/effects";
import { toast } from "react-toastify";

export const handleLogout = () => {
    localStorage.clear();
    // localStorage.clear() does not touch sessionStorage; drop the per-tab
    // impersonation handoff flag so a later login in this tab can't inherit
    // impersonation UI bypasses.
    sessionStorage.removeItem("impersonation_boot");
    window.location.href = "/";
};

export function* handleServerException(
    error: any,
    actionType?: string
): Generator<PutEffect> {
    if (!error && actionType) {
        yield put({ type: actionType });
    } else {
        const errorStatus = error.response?.status;
        switch (errorStatus) {
            case 401:
            case 403:
                toast.error(
                    "User not authenticated to do the request, account manually logging out..."
                );
                handleLogout();
                break;
            default:
                if (actionType) {
                    yield put({ type: actionType });
                }
                break;
        }
    }
}

export function createAction(type: string, payload: any) {
    return {
        type,
        payload,
    };
}

export const ellipsesText = (text: string, limit = 100) => {
    if (text.length <= limit) return text;
    return text.slice(0, limit) + "...";
};

export const slugify = (input: string) =>
    input
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

// Revoked on the next tick, not inline: some WebKit builds cancel the download
// when the object URL disappears in the same task as the click.
export const downloadBlob = (blob: Blob, filename: string) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 0);
};
